import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Founder from "@/components/Founder";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import FloatingCTA from "@/components/FloatingCTA";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative bg-sand-50 text-forest-900 font-sans overflow-x-hidden"
    >
      <Navigation />
      <Hero />
      <Services />
      <About />
      <Founder />
      <Testimonials />
      <Contact />
      <FloatingCTA />
    </main>
  );
}
